import { defineStore } from "pinia"
import { ref, computed } from "vue"
import { useApiStore } from "@/stores/api"

export const useShareStore = defineStore(
	"share",
	() => {
		const api = useApiStore()
		const shares = ref([])

		const reset = () => {
			shares.value = []
		}

		const loadShares = async () => {
			const response = await api.dispatchApiCall("get", `/api/v2/shares`)
			if (response?.data) {
				shares.value = response.data
			}
			return true
		}

		const createShare = async (data) => {
			return api.dispatchApiCall("post", `/api/v2/shares`, data)
		}

		const updateShare = async (data) => {
			return api.dispatchApiCall("patch", `/api/v2/shares/${data.id}`, data)
		}

		const deleteShare = async (shareId) => {
			return api.dispatchApiCall("delete", `/api/v2/shares/${shareId}`)
		}

		const getShareLink = async (shareId) => {
			return api.dispatchWebsiteApiCall("get", `/api/share/${shareId}/getlink`, {
				token: api.token,
				user_id: api.user.id,
			})
		}

		/* access helpers */

		const sharesById = computed(() => {
			let returnArray = []
			shares.value.forEach((share) => {
				returnArray[share.id] = share
			})
			return returnArray
		})

		return {
			reset,
			shares,
			sharesById,
			loadShares,
			createShare,
			updateShare,
			deleteShare,
			getShareLink,
		}
	},
	{
		persist: true,
	}
)
